import { supabase } from "./supabase";

interface ItemMatch {
  item_name: string;
  price: number;
  item_code: string;
  final_score: number;
}

interface SearchMatch {
  search_term: string;
  category: string;
  requested_amount: string;
  requested_unit: string;
  matches: ItemMatch[];
}

interface ShoppingListResponse {
  status: string;
  matches: SearchMatch[];
  parsed_items: number;
  total_price: number;
  result: string;
}

export const createShoppingListWithServer = async (shoppingListId: string): Promise<ShoppingListResponse> => {
  try {
    const { data: shoppingList, error } = await supabase
      .from('shopping_lists')
      .select('list_data')
      .eq('id', shoppingListId)
      .single();

    if (error || !shoppingList) {
      throw new Error('Shopping list not found in Supabase');
    }

    const response = await fetch(`http://localhost:8000/shopping-list/${shoppingListId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(shoppingList.list_data),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Server error (${response.status}): ${errorText}`);
    }

    const serverResponse: ShoppingListResponse = await response.json();
    console.log('Server Response:', {
      status: serverResponse.status,
      matchCount: serverResponse.matches?.length,
      firstMatch: serverResponse.matches?.[0]
    });

    return serverResponse;
  } catch (error) {
    console.error('Error in createShoppingListWithServer:', error);
    throw error;
  }
};

// After creating a new shopping list in Supabase
